import { Button, HStack, Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Text, VStack } from '@chakra-ui/react';
import SelectField from 'components/SelectField';
import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AccountContext } from 'components/AccountContext';
import { getAppTheme, userIsSubscriber } from 'components/Utils/theme';
import Medico from '../../../../../images/modalPsicologo.svg';
import EmojiTriste from '../../../../../images/EmojiTristeVermelho.svg';
import useViewModelTelemed from './useViewModalTelemed';
import ModalSuporte from 'components/Perfil/ModalSuporte';
import { Formik } from 'formik';
import { IoIosArrowBack } from 'react-icons/io';

function ModalTelemedicinaHome(props) {
  const disclosure = props.disclosure;
  const agendamentos = props.cacheAgendamento;
  const refetchAtendimento = props.refetchAtendimento;
  const { user } = useContext(AccountContext);
  const theme = getAppTheme(userIsSubscriber(user));
  const navigate = useNavigate();
  const {
    motivos,
    setMotivoEscolhido,
    modalDesistir,
    modalfuncDesistir,
    modalSuporte,
    motivo_escolhido,
    loading,
    cancelarAtendimento,
    error,
    atendimentoEscolhido,
    setAtendimentoEscolhido,
  } = useViewModelTelemed({ modalCancelamento: disclosure, refetchAtendimento, agendamentos });

  const SelectClient = () => {
    const arrayMotivos = motivos.map((motivo) => motivo.descricao);
    return (
      <SelectField
        name="motivos"
        background={'#F3F3F3'}
        color={'#585858'}
        placeholder="Selecione o motivo"
        variant="outline"
        textAlign="left"
        borderColor="gray.300"
        w={'100%'}
        borderRadius="10px"
        fontWeight="bold"
        options={arrayMotivos}
        onChange={(e) => {
          setMotivoEscolhido(motivos[e]?.ambulatorio_cancelamento_id);
        }}
      />
    );
  };

  useEffect(() => {
    if (agendamentos?.length == 0 || agendamentos === null) {
      disclosure.onClose();
    }
  }, [agendamentos]);

  return (
    <>
      <ModalSuporte disclosure={modalSuporte} />
      <Modal isOpen={disclosure.isOpen} isCentered>
        <ModalOverlay />
        <ModalContent
          maxW="95vw"
          w="95vw"
          minW="320px"
          borderRadius="0.8em"
          p={0}
          maxH="90vh"
          mt={{ base: '20px', md: 'auto' }}
          overflowY="auto"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <ModalBody p={4} w="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="flex-start">
            {atendimentoEscolhido === null && !modalDesistir && (
              <>
                <VStack spacing={6}>
                  <Image src={Medico} mt={4} w="60%" maxW="160px" objectFit="contain" />
                  <Text color={theme.color} fontWeight="bold" fontSize="2xl" textAlign="center">
                    Selecione qual atendimento você deseja prosseguir
                  </Text>
                  <VStack spacing={4} w="100%" maxHeight={'40dvh'} overflowY={'scroll'}>
                    {agendamentos.map((agendamento) => {
                      return (
                        <>
                          <VStack border={`1px solid ${theme.background}`} align={'left'} p={4} borderRadius={'0.8em'}>
                            <Text>Paciente: {agendamento.paciente}</Text>
                            <Text>Procedimento: {agendamento.procedimento}</Text>
                            <Text>Data do atendimento: {agendamento.data + ' às ' + agendamento.inicio}</Text>
                            <Button
                              bg={theme.background}
                              color={theme.fontcolor}
                              borderRadius={'0.8em'}
                              onClick={() => {
                                setAtendimentoEscolhido(agendamento);
                              }}
                            >
                              Continuar
                            </Button>
                          </VStack>
                        </>
                      );
                    })}
                  </VStack>
                </VStack>
              </>
            )}

            {!modalDesistir && atendimentoEscolhido !== null && (
              <>
                <Image src={Medico} mt={10} w={'60%'} maxW="160px" objectFit="contain" mx="auto" />
                <VStack spacing={6}>
                  <Text color={theme.color} fontWeight="bold" fontSize="2xl" textAlign="center">
                    Seu médico já está te esperando
                  </Text>
                  <Text color={theme.color} fontWeight="bold" fontSize="1em" textAlign="center">
                    Quando estiver pronto, é só clicar para iniciar a consulta.
                  </Text>
                  <HStack
                    w="100%"
                    bg="#FFF8E1"
                    borderLeft="5px solid #FFB300"
                    borderRadius="0.7em"
                    p={3}
                    spacing={2}
                    align="flex-start"
                    boxShadow="sm"
                  >
                    <Image src="https://cdn-icons-png.flaticon.com/512/1828/1828843.png" alt="Aviso" boxSize="1.5em" mt={0.5} />
                    <VStack align="start" spacing={0}>
                      <Text color="#B8860B" fontWeight="bold" fontSize="1em" mb={0}>
                        Atenção
                      </Text>
                      <Text color="#B8860B" fontSize="0.98em" lineHeight={1.3}>
                        Em caso de dúvidas, informações erradas em seus documentos prescritos pelos profissionais (médicos, psicólogos e
                        nutricionistas) ou problemas técnicos, entre em contato imediato com o suporte.
                      </Text>
                    </VStack>
                  </HStack>
                  <VStack spacing={4} w="100%">
                    <Button
                      _focus={false}
                      bg={theme.background}
                      color={'white'}
                      w="100%"
                      fontWeight="bold"
                      p={4}
                      borderRadius={'0.8em'}
                      onClick={() => {
                        const nomePartes = atendimentoEscolhido?.paciente.split(' ');
                        const primeiroNome = nomePartes[0];
                        const sobrenome = nomePartes.length > 1 ? nomePartes[1] : '';
                        navigate('/video-chamada', {
                          state: {
                            channelName: `telemedicina_${atendimentoEscolhido.agenda_exames_id}`,
                            userId: `${primeiroNome} ${sobrenome}`,
                            jwt: '123',
                            agenda_exames_id: atendimentoEscolhido.agenda_exames_id,
                          },
                        });
                      }}
                    >
                      Ir para o atendimento
                    </Button>
                    <Button bg={'red'} color="white" variant="outline" w="100%" fontWeight="bold" borderRadius="0.8em" onClick={modalfuncDesistir}>
                      Vish... Quero desistir
                    </Button>
                  </VStack>
                </VStack>
              </>
            )}
            {modalDesistir == true && (
              <>
                <HStack alignItems="center" spacing={2} w="100%" justifyContent="space-between">
                  <Button
                    variant="ghost"
                    p={0}
                    minW="auto"
                    h="40px"
                    w="40px"
                    borderRadius="full"
                    onClick={modalfuncDesistir}
                    _focus={{ boxShadow: 'none' }}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <IoIosArrowBack size={32} color="#9E9E9E" />
                  </Button>
                  <ModalCloseButton
                    position="static"
                    mt={0}
                    boxSize="40px"
                    fontSize="14px"
                    fontWeight={'bold'}
                    _focus={false}
                    color="#9E9E9E"
                    onClick={() => disclosure.onClose()}
                  />
                </HStack>

                <Formik initialValues={{ clients: 0 }} validateOnChange={false} validateOnBlur={false}>
                  <VStack spacing={6}>
                    <Image src={EmojiTriste} mt={4} w={'40%'} />
                    <Text color={'red'} fontWeight="bold" fontSize="1.5em" textAlign="center">
                      Sentimos muito que precise cancelar....
                    </Text>
                    <Text color={'#585858'} fontSize="1.2em" textAlign="center">
                      Selecione o motivo do seu cancelamento
                    </Text>
                    <SelectClient />

                    <VStack w={'100%'}>
                      {error && (
                        <>
                          <Text color={'red'} fontSize="1em" textAlign="center">
                            Falha ao cancelar seu atendimento. Entre em contato com nosso suporte
                          </Text>
                        </>
                      )}

                      <Button
                        bg={'red'}
                        color="white"
                        variant="outline"
                        w="100%"
                        fontWeight="bold"
                        borderRadius="0.8em"
                        loading={loading}
                        disabled={motivo_escolhido === 0 || loading || error}
                        onClick={() => cancelarAtendimento()}
                        mt={'0.5em'}
                      >
                        Cancelar atendimento
                      </Button>
                      <Button
                        bg={theme.background}
                        color="white"
                        variant="outline"
                        w="100%"
                        fontWeight="bold"
                        borderRadius="0.8em"
                        loading={loading}
                        disabled={loading}
                        onClick={() => modalSuporte.onOpen()}
                      >
                        Falar com o suporte
                      </Button>
                    </VStack>
                  </VStack>
                </Formik>
              </>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ModalTelemedicinaHome;
